import React from "react";

/**
 * Reusable section heading with index pin + label + headline.
 */
const SectionHeading = ({
  index,
  label,
  title,
  description,
  align = "left",
  className = "",
}) => {
  return (
    <div className={className}>
      <div
        className={`flex items-center gap-4 mb-8 ${
          align === "center" ? "justify-center" : ""
        }`}
      >
        <span className="font-mono-label text-[10px] text-[var(--kr-gold)]">
          {index}
        </span>
        <span className="w-10 h-px bg-[var(--kr-gold)]/60" />
        <span className="font-mono-label text-[11px] text-[var(--kr-text-muted)]">
          {label}
        </span>
      </div>
      <h2
        className={`font-serif-display text-[var(--kr-text)] text-[clamp(2rem,4.4vw,3.6rem)] max-w-[22ch] ${
          align === "center" ? "mx-auto text-center" : ""
        }`}
      >
        {title}
      </h2>
      {description ? (
        <p
          className={`mt-6 text-[var(--kr-text-muted)] text-[16px] leading-[1.8] max-w-[58ch] ${
            align === "center" ? "mx-auto text-center" : ""
          }`}
        >
          {description}
        </p>
      ) : null}
    </div>
  );
};

export default SectionHeading;
